// Text-driven promo / environment banner visibility.
//
// The banner is shown whenever PROMO_BANNER_TEXT is filled in on the tenant config
// (window.PROMO_BANNER_TEXT). This lets an environment/promo banner be turned on simply
// by setting its text — no separate enable flag to remember.
//
// PROMO_BANNER_ENABLED === false remains an explicit kill switch, so a drafted banner
// message can be kept off in production without clearing the text
// (e.g. config.windermere.js keeps a message staged but disabled).
export function isPromoBannerVisible() {
  if (typeof window === 'undefined') return false
  const t = window.PROMO_BANNER_TEXT
  const hasText = typeof t === 'string' && t.trim().length > 0
  const disabled = window.PROMO_BANNER_ENABLED === false || window.PROMO_BANNER_ENABLED === 'false'
  return hasText && !disabled
}
